import { GUIControllerBase } from "./controllers/GUIControllerBase";
import { IApp } from "./IApp";
import { ChainControllerBase } from "./controllers/ChainControllerBase";


export class App implements IApp {
    public static Inst: App;
    public static get gui() { return App.Inst._guiBase; }
    public static get chain() { return App.Inst._chainBase; }
    

    public readonly version:string = "0.0.1";

    private readonly _instances = new Map<Function, unknown>();
    private _guiBase: GUIControllerBase; 
    private _chainBase: ChainControllerBase; 

    public get gui(){return this._guiBase;}
    public get chain(){return this._chainBase;}

    constructor(version:string) {
        this.version = version;
        console.log(this.version);
        App.Inst=this;
    }

    protected async startAsync()
    {
        this._guiBase = this.getInst(GUIControllerBase);
        this._chainBase = this.getInst(ChainControllerBase);

       // this._guiBase.dialogOkShowAsync("Invitation only mainnet test. If you have not been invited, you risk losing funds as the current LPX is temporary and will be closed before the release with private inquiry to withdraw all funds.");
    }


    public getInst<T>(cls: new (...args: any[]) => T): T {
        const instance = this._instances.get(cls);
        if (!instance) throw new Error(`No instance found for ${cls.name}`);
        return instance as T;
    }

    public addInst<T>(cls: new (...args: any[]) => T, instance: T): void {
        this._instances.set(cls, instance);
    }
}
